import React from 'react';
import PropTypes from 'prop-types';

import { Nav, ButtonBar } from 'C4';

const Header = ({ pathname }) => (
  <div className="header">
    <Nav pathname={pathname} hasBackButton={pathname !== '/' && pathname !== '/main'} />
  </div>
);

export default Header;

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};
